import React, { useState } from "react";
import { Card, CardContent, Tabs, Tab, Box, Typography } from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ConsumptionTab from "./ConsumptionTab";
import ConversationsTab from "./ConversationsTab";
import AuditTab from "./AuditTab";

// Panel de Lucy embebido en el View de un usuario del mantenimiento.
// Requiere que el usuario en sesion pertenezca al grupo Cognito `lucy-admin`
// (o consulte su propio sub si LUCY_SELF_AUDIT esta activo en el backend).
const LucyUserPanel = ({ sub }) => {
  const [tab, setTab] = useState(0);

  if (!sub) return null;

  return (
    <Card variant="outlined" sx={{ mt: 2 }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <SmartToyIcon color="primary" />
          <Typography variant="h5">IA institucional</Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Consumo de tokens, conversaciones y log de auditoría de este usuario.
        </Typography>

        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
        >
          <Tab label="Consumo y cuota" />
          <Tab label="Conversaciones" />
          <Tab label="Auditoría" />
        </Tabs>

        <Box hidden={tab !== 0}>{tab === 0 && <ConsumptionTab sub={sub} />}</Box>
        <Box hidden={tab !== 1}>{tab === 1 && <ConversationsTab sub={sub} />}</Box>
        <Box hidden={tab !== 2}>{tab === 2 && <AuditTab sub={sub} />}</Box>
      </CardContent>
    </Card>
  );
};

export default LucyUserPanel;
